/**
 * A TAB A RÉTEGEN BELÜL MARAD — az `aria-modal` párbeszédek közös csapdája.
 *
 * Két réteg használja: a kéretlen feltöltés lapja (`UploadSheet`, #85) és a
 * lefotózott lap teljes képernyős nézete (`PagePreview`, #87). A fátyol alatti
 * gombokra szökő fókusz azt jelentené, hogy a billentyűzetes ügyfél egy
 * láthatatlan gombot nyom meg.
 */

/** A lap fókuszálható elemei, a DOM sorrendjében — a rejtett fájl-input nélkül. */
function focusablesIn(root: HTMLElement): HTMLElement[] {
  return Array.from(
    root.querySelectorAll<HTMLElement>('button:not([disabled]):not([tabindex="-1"])')
  );
}

/** Körbe a lapon belül: az utolsó után az első, az első előtt az utolsó. */
export function trapTab(event: KeyboardEvent, root: HTMLElement) {
  const items = focusablesIn(root);
  if (items.length === 0) {
    return;
  }
  const first = items[0];
  const last = items[items.length - 1];
  const active = document.activeElement;
  const inside = active instanceof HTMLElement && root.contains(active);

  if (event.shiftKey && (active === first || !inside)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (active === last || !inside)) {
    event.preventDefault();
    first.focus();
  }
}
